module.exports = __webpack_public_path__ + "static/img/ikonaTabela-ON.e7d4aa86.png";